import { CandidateImportRequestsDetailTemplate } from '@/features/agent/candidate_import_requests/templates/CandidateImportRequestsDetailTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/candidates/candidate_import_requests/new/$encryptId/')(
  {
    component: RouteComponent,
  }
);

function RouteComponent() {
  return <CandidateImportRequestsDetailTemplate />;
}
